'use strict';
'use client';
Object.defineProperty(exports, '__esModule', { value: true });
exports.ColorModeButton = void 0;
exports.ColorModeIcon = ColorModeIcon;
exports.ColorModeProvider = ColorModeProvider;
exports.LightMode = exports.DarkMode = void 0;
exports.useColorMode = useColorMode;
exports.useColorModeValue = useColorModeValue;

var _react = require('@chakra-ui/react');
var _nextThemes = require('next-themes');

var React = _interopRequireWildcard(require('react'));
var _lu = require('react-icons/lu');
function _interopRequireWildcard(e, t) {
  if ('function' == typeof WeakMap)
    var r = new WeakMap(),
      n = new WeakMap();
  return (_interopRequireWildcard = function(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = { __proto__: null, default: e };
    if (null === e || ('object' != typeof e && 'function' != typeof e)) return f;
    if ((o = t ? n : r)) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e)
      'default' !== t &&
        {}.hasOwnProperty.call(e, t) &&
        ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) &&
        (i.get || i.set)
          ? o(f, t, i)
          : (f[t] = e[t]));
    return f;
  })(e, t);
}
function _extends() {
  return (
    (_extends = Object.assign
      ? Object.assign.bind()
      : function(n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = arguments[e];
            for (var r in t) ({}.hasOwnProperty.call(t, r) && (n[r] = t[r]));
          }
          return n;
        }),
    _extends.apply(null, arguments)
  );
}
function ColorModeProvider(props) {
  return (
    /*#__PURE__*/
    React.createElement(
      _nextThemes.ThemeProvider,
      _extends(
        {
          attribute: 'class',
          disableTransitionOnChange: true,
          forcedTheme: 'light',
          enableSystem: false,
        },
        props
      )
    )
  );
}
function useColorMode() {
  const { resolvedTheme, setTheme, forcedTheme } = (0, _nextThemes.useTheme)();
  const colorMode = forcedTheme || resolvedTheme;
  const toggleColorMode = () => {
    setTheme('light');

    // setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
  };
  return {
    colorMode: colorMode,
    setColorMode: setTheme,
    toggleColorMode,
  };
}
function useColorModeValue(light, dark) {
  const { colorMode } = useColorMode();
  // return colorMode === 'dark' ? dark : light
  return light;
}
function ColorModeIcon() {
  const { colorMode } = useColorMode();
  return colorMode === 'dark'
    ? /*#__PURE__*/ React.createElement(_lu.LuMoon, null)
    : /*#__PURE__*/ React.createElement(_lu.LuSun, null);
}
const ColorModeButton = (exports.ColorModeButton = /*#__PURE__*/ React.forwardRef(
  function ColorModeButton(props, ref) {
    const { toggleColorMode } = useColorMode();
    return (
      /*#__PURE__*/
      React.createElement(
        _react.ClientOnly,
        {
          fallback: /*#__PURE__*/ React.createElement(_react.Skeleton, {
            boxSize: '9',
          }),
        } /*#__PURE__*/,
        React.createElement(
          _react.IconButton,
          _extends(
            {
              onClick: toggleColorMode,
              variant: 'ghost',
              'aria-label': 'Toggle color mode',
              size: 'sm',
              ref: ref,
            },
            props,
            {
              css: {
                _icon: {
                  width: '5',
                  height: '5',
                },
              },
            }
          ) /*#__PURE__*/,

          React.createElement(ColorModeIcon, null)
        )
      )
    );
  }
));
const LightMode = (exports.LightMode = /*#__PURE__*/ React.forwardRef(function LightMode(
  props,
  ref
) {
  return (
    /*#__PURE__*/
    React.createElement(
      _react.Span,
      _extends(
        {
          color: 'fg',
          display: 'contents',
          className: 'chakra-theme light',
          colorPalette: 'gray',
          colorScheme: 'light',
          ref: ref,
        },
        props
      )
    )
  );
}));
const DarkMode = (exports.DarkMode = /*#__PURE__*/ React.forwardRef(function DarkMode(props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(
      _react.Span,
      _extends(
        {
          color: 'fg',
          display: 'contents',
          className: 'chakra-theme dark',
          colorPalette: 'gray',
          colorScheme: 'dark',
          ref: ref,
        },
        props
      )
    )
  );
}));
